<div class="page-container">
  <app-header></app-header>
  <div class="layout-container">
    <h1>Página no encontrada</h1>
    <p>Lo sentimos, la página que estás buscando no existe o ha sido movida. Verifica la URL o vuelve a la página de inicio.</p>
  </div>
  <app-footer></app-footer>
</div>